import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Studio data is mostly customer-scoped reads. 60s staleTime smooths
      // tab switches without hammering the API; mutations invalidate
      // explicit keys so the staleness doesn't bite the user.
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Centralized query keys so we can invalidate by prefix without dancing
// around string typos.
export const qk = {
  me: ['me'] as const,
  designs: (params?: unknown) => ['designs', params ?? null] as const,
  design: (id: string) => ['design', id] as const,
  designVariantOptions: (id: string) => ['design', id, 'variant-options'] as const,
  activity: ['activity'] as const,
  brandKit: ['brand-kit'] as const,
  folders: ['folders'] as const,
  team: ['team'] as const,
  photos: (params?: unknown) => ['photos', params ?? null] as const,
};
